import { StyleSheet, Dimensions } from 'react-native';

const { width: SCREEN_WIDTH } = Dimensions.get('window');

// 主题色
const COLORS = {
  light: {
    background: '#FFFFFF',
    tabBarBackground: '#FFFFFF',
    tabText: '#666666',
    tabTextActive: '#333333',
    indicator: '#FF2442',
    border: '#F0F0F0',
    separator: '#EEEEEE',
  },
  dark: {
    background: '#1C1C1E',
    tabBarBackground: '#2C2C2E',
    tabText: '#8E8E93',
    tabTextActive: '#FFFFFF',
    indicator: '#FF453A',
    border: '#38383A',
    separator: '#38383A',
  },
};

export type ThemeType = 'light' | 'dark';

export const getColors = (theme: ThemeType) => COLORS[theme];
export const getScreenWidth = () => SCREEN_WIDTH;

export const createStyles = (theme: ThemeType = 'light') => {
  const colors = COLORS[theme];

  return StyleSheet.create({
    // 容器
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    
    // Tab 栏
    tabBarContainer: {
      backgroundColor: colors.tabBarBackground,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: colors.border,
    },
    tabBarContainerBottom: {
      borderBottomWidth: 0,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: colors.border,
    },
    
    // 面板容器
    panelContainer: {
      flex: 1,
    },
    panelWrapper: {
      width: SCREEN_WIDTH,
      flex: 1,
    },
    
    // 面板
    panel: {
      flex: 1,
      backgroundColor: colors.background,
    },
    panelHidden: {
      // 用于惰性加载时隐藏的面板
    },
    
    // 滑动容器
    swipeContainer: {
      flex: 1,
      flexDirection: 'row',
    },
    
    // 列表样式
    listContainer: {
      flex: 1,
    },
    listItem: {
      padding: 16,
      backgroundColor: colors.background,
    },
    listSeparator: {
      height: StyleSheet.hairlineWidth,
      backgroundColor: colors.separator,
    },
    
    // 空状态
    emptyContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 60,
    },
    emptyText: {
      fontSize: 14,
      color: colors.tabText,
    },
    
    // 加载状态
    loadingContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 60,
    },
    
    // 错误状态
    errorContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 60,
    },
    errorText: {
      fontSize: 14,
      color: '#FF3B30',
      marginBottom: 12,
    },
    retryButton: {
      paddingHorizontal: 20,
      paddingVertical: 8,
      backgroundColor: '#007AFF',
      borderRadius: 4,
    },
    retryButtonText: {
      fontSize: 14,
      color: '#FFFFFF',
    },
  });
};

export default createStyles;
